<template>
  <div id="ticketing-step-3" v-if="step === 3 || step === 4">
    <div class="ticketing-content ticketing-checkout-page">
      <div class="card">
        <div class="card-header bg-light">
          <div class="card-header-title text-muted">
            Tóm tắt đơn hàng
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-nowrap card-table">
            <thead>
              <tr>
                <th>Mô tả</th>
                <th class="text-center">Số lượng</th>
                <th class="text-right">Thành tiền</th>
              </tr>
            </thead>
            <tbody>
              <tr class="ticketing-cart-item" v-for="item in getCart()" :key="item.id">
                <td class="ticketing-cart-item-name">
                  {{ item.name }}
                </td>
                <td class="ticketing-cart-item-quantity text-center">
                  <div class="quantity-toggle" v-if="item.type === 'concession'">
                    <a class="btn btn-sm btn-rounded-circle btn-white"
                       :class="{ 'disabled': item.quantity === 0 }"
                       @click="updateConcession(item.id, 'remove')">-</a>
                    <input type="text" min="0" max="10"
                           class="form-control form-control-flush text-dark text-center d-inline"
                           :value="item.quantity" style="width: 30px;" readonly>
                    <a class="btn btn-sm btn-rounded-circle btn-white"
                       :class="{ 'disabled': item.quantity === 10 }"
                       @click="updateConcession(item.id, 'add')">+</a>
                  </div>

                  <div v-else>{{ item.quantity }}</div>
                </td>
                <td class="ticketing-cart-item-price text-right">
                  {{ useFormatting().formatCurrency(item.price) }}
                </td>
              </tr>

              <tr>
                <td>Phí tiện ích</td>
                <td class="text-center"></td>
                <td class="text-right">{{ useFormatting().formatCurrency(amount.fee) }}</td>
              </tr>
              <tr v-if="amount.discount > 0">
                <td colspan="2" class="text-danger">Giảm giá</td>
                <td class="text-right text-danger">-{{ useFormatting().formatCurrency(amount.discount) }}</td>
              </tr>
              <tr>
                <td colspan="2">Tổng</td>
                <td class="text-right">{{ useFormatting().formatCurrency(amount.total) }}</td>
              </tr>
              <tr v-if="isCouponEnabled()">
                <td>Mã giảm giá</td>
                <td colspan="2" class="text-right text-wrap">
                  <div class="rơw">
                    <div class="input-group input-group-merge w-50 w-sm-75 ml-auto">
                      <input
                          type="text"
                          class="form-control form-control-appended"
                          v-model="form.coupon.code"
                          @input="onCouponInput"
                          @compositionend="onCouponEnter"
                          @keydown.enter.prevent="onCouponEnter"
                          @change="onCouponEnter"
                          placeholder="Nhập mã giảm giá"
                          @blur="onCouponBlur"
                          :class="{
                            'is-invalid': form.coupon.status === 'invalid' && form.coupon.processing === false,
                            'is-valid': form.coupon.status === 'valid' && form.coupon.processing === false
                          }"
                          :disabled="form.coupon.processing"
                      >
                      <div class="input-group-append">
                        <div class="input-group-text">
                          <span
                              class="fe"
                              :class="{
                                'spinner-border spinner-border-sm': form.coupon.processing,
                                'fe-check text-success': form.coupon.status === 'valid' && form.coupon.processing === false,
                                'fe-x text-danger': form.coupon.status === 'invalid' && form.coupon.processing === false
                              }"
                          >
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                        class="d-inline-block"
                        v-if="form.coupon.status !== 'pending' && form.coupon.processing === false"
                        :class="{
                            'invalid-feedback': form.coupon.status === 'invalid',
                            'valid-feedback': form.coupon.status === 'valid'
                          }"
                    >
                      {{ form.coupon.message }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <contact-form
          :contact="form.contact"
          :violations="violations"
          @update:contact="form.contact = $event"
      />

      <payment-method-form
          :payment="form.payment"
          :user="user"
          :amount="amount"
          :show-apple-pay="isApplePayEnabled()"
          bank-transfer-description="Tự động xuất mã vé trong 30s sau khi chuyển khoản"
          @update:payment="form.payment = $event"
          @open:modal="emit('open:modal', $event)"
      />

      <div class="card d-lg-none">
        <div class="card-body">
          Vé đã mua không thể đổi hoặc hoàn tiền.
          <br />Mã vé sẽ được gửi <strong>01</strong> lần qua số điện thoại và email đã nhập.
          Vui lòng kiểm tra lại thông tin trước khi tiếp tục.
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="moveekCreditsModal" role="dialog" v-if="user.authenticated">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="card mb-0">
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="card-header-title">
                  Moveek Credits
                </h4>
              </div>
              <div class="col-auto">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="alert alert-light text-center">
              <a :href="root.url('orn_web_user_credits')" class="h1 font-thin block">{{ useFormatting().formatCurrency(user.balance) }}</a>
              <span class="text-muted text-small d-block">Số dư</span>
            </div>

            <p>Số dư tài khoản <strong>Moveek Credits</strong> của bạn
              không đủ để thanh toán cho đơn hàng này.</p>

            <p class="mb-0">Hãy <a :href="root.url('orn_web_user_deposit')" target="_blank">nạp thêm</a> hoặc tiếp tục thanh toán bằng các hình thức khác.</p>
          </div>
          <div class="card-footer">
            <a class="btn btn-dark" :href="root.url('orn_web_user_deposit')" target="_blank">Nạp thêm</a>
            <button type="button" class="btn btn-light float-right" data-dismiss="modal" aria-label="Close">Đóng</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="orderConfirmationModal" tabindex="-1" role="dialog" style="z-index: 9999;">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="card mb-0">
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="card-header-title">
                  Xác nhận đơn hàng
                </h4>
              </div>
              <div class="col-auto">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <ul class="list-group list-group-flush list mb-3">
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Rạp</div>
                  <div class="col">{{ showtime.cinema?.name }}</div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Phim</div>
                  <div class="col">{{ showtime.movie?.name }}</div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Suất</div>
                  <div class="col">
                    <strong>{{ useFormatting().formatDateTime(showtime.time) }}</strong>
                  </div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Ghế</div>
                  <div class="col">
                    <span class="font-weight-bold" v-for="(seat, i) in cart.seats" :key="seat.id">
                      {{ seat.name }}<span v-if="i < cart.seats.length - 1">, </span>
                    </span>
                  </div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Thông tin<br />cá nhân</div>
                  <div class="col">
                    {{ form.contact.name }}<br />
                    {{ form.contact.phone }}<br />
                    {{ form.contact.email }}
                  </div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Phương thức<br />thanh toán</div>
                  <div class="col">{{ useFormatting().formatPaymentMethod(form.payment.gateway, form.payment.method) }}</div>
                </div>
              </li>
              <li class="list-group-item px-0">
                <div class="row align-items-center">
                  <div class="col-4 col-sm-3">Giá trị<br />đơn hàng</div>
                  <div class="col">
                    <strong>{{ useFormatting().formatCurrency(amount.total) }}</strong>
                  </div>
                </div>
              </li>
            </ul>

            <a
                href="#"
                class="btn btn-lg btn-danger btn-block"
                :class="{ disabled: completing }"
                @click.prevent="emit('create:booking')"
            >
              {{ completing
                ? 'Đang xử lý, vui lòng chờ trong ít phút'
                : 'Tiến hành thanh toán'
              }}

            </a>

            <div class="alert alert-danger mt-4 mb-0" v-if="errors.length > 0">
              <p><strong>Có lỗi xảy ra</strong></p>
              <p class="mb-0" v-for="error in errors" :key="error" v-html="error"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, watch } from 'vue'
import axios from 'axios'
import { UAParser } from 'ua-parser-js';
import { useFormatting } from '../composables/formatting';
import ContactForm from './ContactForm.vue';
import PaymentMethodForm from './PaymentMethodForm.vue';
import debounce from 'lodash.debounce';

const props = defineProps({
  cart: {
    type: Object,
    required: true
  },
  user: {
    type: Object,
    required: true
  },
  showtime: {
    type: Object,
    required: true
  },
  features: {
    type: Object,
    required: true,
    default: {}
  },
  step: {
    type: Number,
    required: true
  },
  contact: {
    type: Object,
    required: true,
    default: () => ({
      name: null,
      phone: null,
      email: null
    })
  },
  payment: {
    type: Object,
    required: true,
    default: () => ({
      gateway: 'moveek',
      method: 'bank-transfer'
    })
  },
  coupon: {
    type: Object,
    required: true,
    default: () => ({
      code: '',
      processing: false,
      status: 'pending',
      message: ''
    })
  },
  amount: {
    type: Object,
    required: true,
  },
  violations: {
    type: Array,
    required: true,
    default: []
  },
  errors: {
    type: Array,
    required: true,
    default: []
  },
  completing: {
    type: Boolean,
    required: true,
    default: false
  }
})

const emit = defineEmits([
  'update:contact',
  'update:payment',
  'create:booking',
  'open:modal',
  'update:concession',
  'update:cart-coupon'
])

const root = inject('root')

const form = ref({
  contact: props.contact,
  payment: props.payment,
  coupon: props.coupon,
})

const resetPayment = () => {
  form.value.payment.gateway = 'moveek'
  form.value.payment.method = 'bank-transfer'
}

const getCart = () => {
  const data = []

  const tickets = {}
  props.cart.seats.forEach(seat => {
    const categoryName = seat.category.name
    if (!tickets[categoryName]) {
      tickets[categoryName] = {price: seat.price, quantity: 0}
    }
    tickets[categoryName].quantity++
  })

  Object.entries(tickets).forEach(([categoryName, {price, quantity}]) => {
    if (quantity > 0) {
      data.push({
        type: 'ticket',
        name: categoryName,
        quantity,
        price: quantity * price,
        description: `${quantity}× ${categoryName}`,
      })
    }
  })

  if (Array.isArray(props.cart.concessions)) {
    props.cart.concessions.forEach(item => {
      if (item.quantity > 0) {
        data.push({
          id: item.id,
          type: 'concession',
          name: item.name,
          quantity: item.quantity,
          price: item.quantity * item.price,
          description: `${item.quantity}× ${item.name}`,
        })
      }
    })
  }

  return data
}

const onCouponEnter = debounce(async () => {
  const couponCode = form.value.coupon.code.trim()
  if (couponCode) {
    form.value.coupon.processing = true

    await axios
        .post('/api/v1/coupons/verify', {
          couponCode: couponCode,
          phoneNumber: form.value.contact.phone
        }).then(response => {
          form.value.coupon.status = 'valid'
          form.value.coupon.message = 'Chúc mừng! Bạn được giảm ' + useFormatting().formatCurrency(response.data.value) + ' trên đơn hàng này.'

          const data = {
            id: response.data.id,
            value: response.data.value,
          }

          // update cart
          emit('update:cart-coupon', { coupon: data })
        })
        .catch(error => {
          form.value.coupon.status = 'invalid'
          form.value.coupon.message = error.response?.data?.violations[0].title

          // update cart
          emit('update:cart-coupon', { coupon: null })
        })
  } else {
    form.value.coupon.status = 'pending'
    form.value.coupon.message = ''

    // update cart
    emit('update:cart-coupon', { coupon: null })
  }

  form.value.coupon.processing = false
}, 1000)

const onCouponInput = (event) => {
  // ensure uppercase and keep v-model in sync
  form.value.coupon.code = (event.target.value || '').toUpperCase()
  // trigger debounced verification
  onCouponEnter()
}

const onCouponBlur = () => {
  if (typeof onCouponEnter.flush === 'function') {
    onCouponEnter.flush()
  } else {
    onCouponEnter()
  }
}

const isApplePayEnabled = () => {
  const { os } = UAParser(window.navigator.userAgent);

  return props.features['booking.checkout.capabilities.applepay'] === true && os.name !== 'Android'
}

const isCouponEnabled = () => {
  return props.features['booking.checkout.capabilities.coupon'] === true
}

const updateConcession = debounce((concessionId, action) => {
  const concession = props.cart.concessions.find(c => c.id === concessionId)
  emit('update:concession', { concession, action })
}, 100) // 100ms debounce

// watch order changes
watch(props.amount, () => {
  // disable moveek credits if balance is insufficient
  if (form.value.payment.gateway === 'moveek'
      && form.value.payment.method === 'moveek-credits'
      && props.user.authenticated
      && props.user.balance < props.amount.total) {
    resetPayment()
  }
})

// whenever the prop changes, update the local copy
watch(() => props.contact, (value) => {
  form.value.contact = value
}, { deep: true })

watch(() => props.payment, (value) => {
  form.value.payment = value
}, { deep: true })

// whenever the local copy changes, tell the parent
watch(() => form.value.contact, (value) => {
  emit('update:contact', value)
}, { deep: true })

watch(() => form.value.payment, (value) => {
  emit('update:payment', value)
}, { deep: true })

</script>

<style scoped>
.required:before {
  content: "* ";
  color: #dc3545;
}
</style>
